import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { STATE_KEYS, StateService } from '@shared/services/state-service';
import { Observable, rx } from '@shared/rx';
import { compact, filter, flatten, has, includes, map, set } from 'lodash';
import {
  INotificationBoxItem,
  INotificationHTML,
  NotificationContent,
  NotificationContentType,
} from '@shared/types/ui/components';

@Component({
  selector: 'xvi-notification-box',
  templateUrl: './notification-box.component.html',
  styleUrls: ['./notification-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationBoxComponent implements OnInit {
  public notifications$: Observable<INotificationBoxItem[]>;
  private stringBreak: INotificationHTML = {
    type: NotificationContentType.HTML,
    wrapItem: true,
    htmlString: '',
  };

  public constructor(private stateService: StateService) {}

  public ngOnInit(): void {
    this.initNotificationObs();
  }

  private initNotificationObs(): void {
    this.notifications$ = this.stateService
      .select(STATE_KEYS.NOTIFICATION_BOX)
      .pipe(
        rx.map((notifications: INotificationBoxItem[]) => {
          const handledUnitedIds: string[] = [];

          return compact(
            map(notifications, (notificationItem) => {
              if (!has(notificationItem, 'unitedId')) return notificationItem;

              const unitedId: string = notificationItem.unitedId;
              const unitedItems: INotificationBoxItem[] = filter(
                notifications,
                { unitedId },
              );

              if (includes(handledUnitedIds, unitedId)) return;
              handledUnitedIds.push(unitedId);

              return set(
                { ...notificationItem },
                'content',
                this.getUnitedContent(unitedItems),
              );
            }),
          );
        }),
      );
  }

  private getUnitedContent(
    unitedItems: INotificationBoxItem[],
  ): NotificationContent {
    return compact(
      flatten(
        map(unitedItems, (unitedItem: INotificationBoxItem, index: number) => {
          if (index > 0 && unitedItem.isSingleNotificationMsg) return;

          if (unitedItems.length === 1 || index === unitedItems.length) {
            return [...unitedItem.content];
          }

          return [...unitedItem.content, this.stringBreak];
        }),
      ),
    );
  }
}
